import Vue from "vue";
import Vuex from "vuex";

import common from "./common";
import landing from "./landing";

import member from "./member";

import cal from "./cal";
import corp from "./corp";
import director from "./director";
import funeral from "./funeral";

import obituary from "./obituary";
import obituaryMember from "./obituaryMember";

import registObituary from "./registObituary";
import notice from "./notice";
import code from "./code";
import faq from "./faq";

import format from "./format";
import addressSearch from "./addressSearch";
import mortuary from "./mortuary";
import surName from "./surName";
import grave from "./grave";
import music from "./music";
import tablet from "./tablet";
import tablet2 from "./tablet2";
import tablet3 from "./tablet3";
import account from "./account";

import memo from "./memo";
import payback from "./payback";
import question from "./question";
import certify from "./certify";
import skinBanner from "./skinBanner";
import obituaryMessage from "./obituaryMessage";

import design from "./design";

Vue.use(Vuex);

export default new Vuex.Store({
  mode: "history",
  modules: {
    common,
    landing,
    member,

    //
    cal,
    corp,
    director,
    funeral,

    skinBanner,
    //
    obituary,
    obituaryMember,
    registObituary,
    obituaryMessage,

    code,
    notice,
    faq,

    format,
    addressSearch,
    mortuary,
    surName,
    grave,
    music,
    tablet,
    account,

    memo,
    tablet2,
    tablet3,
    payback,
    question,
    certify,
    design
  },
  state: {
    /* User */
    memberName: null,
    memberEmail: null,
    userAvatar: null,
    /* NavBar */
    isNavBarVisible: true,
    /* FooterBar */
    isFooterBarVisible: true,
    /* Aside */
    isAsideVisible: true,
    isAsideMobileExpanded: false
  },

  mutations: {
    /* A fit-them-all commit */
    basic(state, payload) {
      state[payload.key] = payload.value;
    },
    /* User */
    user(state, payload) {
      if (payload.name) {
        state.memberName = payload.name;
      }
      if (payload.email) {
        state.memberEmail = payload.email;
      }
      if (payload.avatar) {
        state.userAvatar = payload.avatar;
      }
    },
    /* Aside Mobile */
    asideMobileStateToggle(state, payload = null) {
      const htmlClassName = "has-aside-mobile-expanded";
      let isShow;
      if (payload != null) {
        isShow = payload;
      } else {
        isShow = !state.isAsideMobileExpanded;
      }
      if (isShow) {
        document.documentElement.classList.add(htmlClassName);
      } else {
        document.documentElement.classList.remove(htmlClassName);
      }
      state.isAsideMobileExpanded = isShow;
    }
  }
});
